import { TileInformationDataList, TileInformationDataListItemStat, TileInformationDataListItemStatType } from "@/api/dtos";
import Icon from "@/components/layouts/Icon/Icon";
import { Box, Chip, Divider, ListItemText, SxProps } from "@mui/material";
import { ComponentType, FC, Fragment, useMemo } from "react";
import { ITileInformationDataComponentProps } from "..";
import { StyledList, StyledListItem, StyledListItemIcon } from "../..";

interface ITileInformationDataListItemStatComponentProps {
    stat: TileInformationDataListItemStat;
}

const TileInformationDataListItemStatChip: FC<ITileInformationDataListItemStatComponentProps> = ({ stat }) => {
    const styles = useMemo(() => {
        if (!stat.sxStyles) {
            return undefined;
        }

        return eval(`(${stat.sxStyles})`) as SxProps;
    }, [stat.sxStyles]);

    return (
        <Chip
            sx={styles}
            label={stat.value} 
            size="small" 
        />
    )
}

const TileInformationDataListItemStatText: FC<ITileInformationDataListItemStatComponentProps> = ({ stat }) => {
    const styles = useMemo(() => {
        if (!stat.sxStyles) {
            return undefined;
        }

        return eval(`(${stat.sxStyles})`) as SxProps;
    }, [stat.sxStyles]);

    return (
        <Box
            sx={styles}
        >
            {stat.value}
        </Box>
    )
}


const TileInformationDataListItemStatMapping: Record<TileInformationDataListItemStatType, ComponentType<ITileInformationDataListItemStatComponentProps>> = {
    [TileInformationDataListItemStatType.Chip]: TileInformationDataListItemStatChip,
    [TileInformationDataListItemStatType.Text]: TileInformationDataListItemStatText
}

const TileInformationDataListComponent: FC<ITileInformationDataComponentProps<TileInformationDataList>> = ({ data }) => {

    return (
        <StyledList>
            {
                data.items?.map((item, i, entireList) => (
                    <Fragment key={i}>
                        <StyledListItem>
                            {
                                item.iconPrefix && item.iconName && (
                                    <StyledListItemIcon
                                        sx={{
                                            color: (theme) => theme.palette.mode === 'dark' ? 
                                                item.iconColorDark : 
                                                item.iconColorLight
                                        }}
                                    >
                                        <Icon icon={{ prefix: item.iconPrefix as any, iconName: item.iconName as any }} size="lg" fixedWidth />
                                    </StyledListItemIcon>
                                )
                            }
                            <ListItemText 
                                primary={item.title && (
                                    <Box
                                        sx={{
                                            color: (theme) => theme.palette.mode === 'dark' ? 
                                                item.titleColorDark : 
                                                item.titleColorLight
                                        }}
                                    >
                                        {item.title}
                                    </Box>
                                )}
                                secondary={item.subtitle && (
                                    <Box
                                        sx={{
                                            color: (theme) => theme.palette.mode === 'dark' ? 
                                                item.subtitleColorDark : 
                                                item.subtitleColorLight
                                        }}
                                    >
                                        {item.subtitle}
                                    </Box>
                                )}
                            />
                            {
                                item.stats && item.stats.length > 0 && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                        }}
                                    >
                                        {
                                            item.stats.map((stat, j) => {
                                                const Component = TileInformationDataListItemStatMapping[stat.type];

                                                return (
                                                    <Component key={j} stat={stat} />
                                                )
                                            })
                                        }
                                    </Box>
                                )
                            }
                        </StyledListItem>
                        {
                            i < entireList.length - 1 && <Divider />
                        }
                    </Fragment>
                ))
            }
        </StyledList>
    )
}

export default TileInformationDataListComponent;